// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.career-projection .loading {
  position: absolute;
  top: 0;
  left: 361px;
  width: calc(100% - 370px);
  height: 100%;
  background: rgb(255, 255, 255);
  z-index: 1;
}
.career-projection .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.career-projection .icon svg path {
  stroke: white;
}
.career-projection .fw-500 {
  font-weight: 500;
  font-size: 18px;
}
.career-projection .btn-clear-carrer {
  border-radius: 50rem;
  background: #6d68aa;
  border: none;
  color: white;
  padding: 3px 20px;
  position: relative;
  margin: 0 10px;
}
.career-projection .btn-search-carrer {
  border-radius: 50rem;
  background: #6d68aa;
  border: none;
  color: white;
  padding: 3px 20px;
  position: relative;
}
.career-projection button::after {
  border-radius: 50rem;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.career-projection button:hover::after {
  background: rgba(255, 255, 255, 0.1);
}
.career-projection button:active::after {
  background: rgba(0, 0, 0, 0.05);
  box-shadow: inset 1px 1px 2px rgba(255, 255, 255, 0.5), 1px 1px 2px rgba(0, 0, 0, 0.5);
}
.career-projection .colaborators-list {
  list-style: none;
  padding: 0 10px;
}
.career-projection .colaborators-list li {
  border: 1px solid rgba(0, 0, 0, 0.35);
  padding: 8px;
  border-radius: 10px;
  transition: height 0.3s ease;
}
.career-projection .colaborators-list li img {
  width: 50px;
  height: 50px;
}
.career-projection .colaborators-list li .col-1, .career-projection .colaborators-list li .col-2, .career-projection .colaborators-list li .col-3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.career-projection .colaborators-list li span {
  font-size: 14px;
}
.career-projection .colaborators-list li span.title {
  font-size: 18px;
  font-weight: 500;
}
.career-projection .colaborators-list li .body {
  width: 100%;
  height: 100px;
  background: red;
}`, "",{"version":3,"sources":["webpack://./src/Views/CareerProjection/careerProjection.sass"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AADR;AAGI;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAGQ;EACI,aAAA;AADZ;AAGI;EACI,gBAAA;EACA,eAAA;AADR;AAGI;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AADR;AAGI;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AADR;AAIQ;EACI,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AAFZ;AAIQ;EACI,oCAAA;AAFZ;AAIQ;EACI,+BAAA;EACA,sFAAA;AAFZ;AAII;EACI,gBAAA;EACA,eAAA;AAFR;AAIQ;EACI,qCAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;AAFZ;AAIY;EACI,WAAA;EACA,YAAA;AAFhB;AAIY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAFhB;AAIY;EACI,eAAA;AAFhB;AAIY;EACI,eAAA;EACA,gBAAA;AAFhB;AAIY;EACI,WAAA;EACA,aAAA;EACA,eAAA;AAFhB","sourcesContent":[".career-projection\n    & .loading\n        position: absolute\n        top: 0\n        left: 361px\n\n        width: calc(100% - 370px)\n        height: 100%\n        background: rgba(255,255,255,1)\n        z-index: 1\n\n    & .icon\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        padding: 8px\n        margin: 0 10px\n        display: flex\n        align-items: center\n        justify-content: center\n\n        & svg path\n            stroke: white\n\n    & .fw-500\n        font-weight: 500\n        font-size: 18px\n\n    & .btn-clear-carrer\n        border-radius: 50rem\n        background: #6d68aa\n        border: none\n        color: white\n        padding: 3px 20px\n        position: relative\n        margin: 0 10px\n\n    & .btn-search-carrer\n        border-radius: 50rem\n        background: #6d68aa\n        border: none\n        color: white\n        padding: 3px 20px\n        position: relative\n\n    & button\n        &::after\n            border-radius: 50rem\n            content: \"\"\n            position: absolute\n            width: 100%\n            height: 100%\n            top: 0\n            left: 0\n\n        &:hover::after\n            background: rgba(255,255,255,.1)\n\n        &:active::after\n            background: rgba(0,0,0,.05)\n            box-shadow: inset 1px 1px 2px rgba(255,255,255,.5), 1px 1px 2px rgba(0,0,0,.5)\n\n    & .colaborators-list\n        list-style: none\n        padding: 0 10px\n\n        & li\n            border: 1px solid rgba(0,0,0, .35)\n            padding: 8px\n            border-radius: 10px\n            transition: height .3s ease\n\n            & img\n                width: 50px\n                height: 50px\n\n            .col-1, .col-2, .col-3\n                display: flex\n                flex-direction: column\n                align-items: center\n                justify-content: center\n\n            & span\n                font-size: 14px\n\n            & span.title\n                font-size: 18px\n                font-weight: 500\n\n            & .body\n                width: 100%\n                height: 100px\n                background: red\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
